import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Moment from 'react-moment';
import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../generics/help';
import LabelForm from '../../components/LabelForm';
import SelectForm from '../../components/SelectForm';
import { clinicHistoryYearsHasHc, donationTypeExtraction, labSectionsByHf, pdfIMSS } from '../../libs/services';
import { Table } from 'react-bootstrap';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../config');

class DailyBiometrics extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

		this.setTable = this.setTable.bind(this);
        this.onPrint = this.onPrint.bind(this);

		this.state = {
			health_facilities_id:'',
            year:'',
            init_month:'',            
            years:[],
            months:[
                {value:'1', text:'Enero'},
                {value:'2', text:'Febrero'},
                {value:'3', text:'Marzo'},
                {value:'4', text:'Abril'},
                {value:'5', text:'Mayo'},
                {value:'6', text:'Junio'},
                {value:'7', text:'Julio'},
                {value:'8', text:'Agosto'},
                {value:'9', text:'Septiembre'},
                {value:'10', text:'Octubre'},
                {value:'11', text:'Noviembre'},
                {value:'12', text:'Diciembre'},
            ],
			listado:[],
            columns:[
				{title:'Día'},
				{title:'Donantes'},
				{title:'No Donantes'},
				{title:'Total'}
			],
			filename:"Informe Diario de Biometrìa Hemàtica",

			date_hour:"",
			medical:"",
			totals:'',
			start_date:'',
			end_date:''
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

	}

	async componentDidMount(){
        var id = sessionStorage.getItem('health_facilities_id');
        var options = [];

        var response = await clinicHistoryYearsHasHc(id);
        if(response){
            options = response.map((res)=>{
                var obj = {
                    value: res,
                    text:res
                };

                return obj;
            });

            this.setState({years: options});
        }

		await this.setTable();
	}

	setTable(){
		this.$el = $(this.el);

        var obj = {
            health_facilities_id: this.state.health_facilities_id,
			year: this.state.year,
			init_month: this.state.init_month,
        };

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [                
				{
                	extend: 'excelHtml5',
                	title: this.state.filename,
                	action: (e, dt, node, config)=>{
                        this.props.printExcelReport(this.state.filename, 'daily_biometrics', obj);
                    }
            	},
                {
                    text:'PDF',
                    action: (e, dt, node, config)=>{
                        this.props.printPdfIMSSReports('daily_biometrics', obj);
                    }
                }
            ],
			data: this.state.listado,
			columns:this.state.columns,			
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
			},
			paging:false,
			ordering:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.dt-button').disable();
		}else {
			table.buttons('.dt-button').enable();
		}
	}

	handleChange(e){
		
		this.setState({
			[e.target.name]: e.target.value
		});
		
		setTimeout(()=>{
			if(this.state.year !== "" && this.state.init_month !== ""){
				let value = parseInt(this.state.init_month);
				let month = value < 10 ? '0'+(value) : value;
				let nextMonth = value < 10 ? '0'+(value+1) :  value === 12 ? '01' : value + 1;
				let nextYear = value === 12 ? parseInt(this.state.year) + 1 : this.state.year;
				this.setState({
					start_date: this.state.year+'-'+month+'-'+26,
					end_date: nextYear+'-'+nextMonth+'-'+25,
				});			
			}
		}, 500);
		

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}
	}

	searching(){

		if(this.isValidForm()){
			if(this.dateCompare()){
				var obj = {
					health_facilities_id: this.state.health_facilities_id,
					year: this.state.year,
                    init_month: this.state.init_month,
				}
				
                this.props.waiting.handleShow('Buscando...');
                fetch(Config.default.apiGateway.URL+'reports_imss/daily_biometrics',{
                    method: 'POST',
                    body:JSON.stringify(obj),
                    headers: new Headers({
                        'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
                        'Accept'		: 'application/json',
                        'Content-Type'	: 'application/json'
                    })
                }).then(res => {
                    this.props.waiting.handleClose();

                    if(res.ok){
                        return res.json();
                    }else{
                        res.text().then((msg)=>{
                            swal('Error', msg, 'error');
                        });
                    }
                }).then(async response => {
                    if(response !== undefined){
                        var list = [];
                        var columns = [
							{title:'Día'},
							{title:'Donantes'},
							{title:'No Donantes'},
							{title:'Total'}
						];

						response.daily_totals.forEach((total)=>{
							list.push([								
								total.day+'/'+total.month,
								total.donors,
								total.no_donors,
								total.total
							]);
						})

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							//this.$el.empty();

                            this.setState({
                                listado: list,
								totals: response.totals
                                //columns:columns,
                            });
                            
						}, 1000);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1500);

                        /*this.setState({
                            listado: list,
                            columns: columns
                        });*/

                    }
                });
               
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;
		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}
		
		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

    onPrint(type){
        var obj = {
            health_facilities_id: this.state.health_facilities_id,
            year: this.state.year,
            init_month: this.state.init_month,
        }

        if(type === 'excel'){
            this.props.printExcelReport(this.state.filename, 'daily_biometrics', obj);
        }else{
            this.props.printPdfIMSSReports('daily_biometrics', obj);
        }
    }

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					{this.state.filename}
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_imss"} 
		            submenu={"help_daily_biometrics"}  />

				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>												
                                <div className="form-group">
                                    <LabelForm text="Años" />
                                    <SelectForm 
                                        id="year"
                                        value={this.state.year}
                                        options={this.state.years}
                                        handleChange={this.handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <LabelForm text="Mes" />
                                    <SelectForm 
                                        id="init_month"
                                        value={this.state.init_month}
                                        options={this.state.months}
                                        handleChange={this.handleChange}
                                        required
                                    />
                                </div>

							
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline",fontSize:'16px'}}>
										<span>
											{this.state.filename}
										</span>
									</div>
									<div className="col-xs-12" >
										<span>
											Información Del:  {this.state.start_date !== "" ?
												moment(this.state.start_date).format("DD/MM/YYYY")
											: ''}    
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: {this.state.end_date !== "" ?
												moment(this.state.end_date).format("DD/MM/YYYY")
											: ''}
										</span>
									</div>

								</div>

                                {/*<div className="col-xs-12 form-group" style={{textAlign:'right'}}>
									<button type="button" className="btn btn-default" disabled={this.state.listado.length === 0} onClick={(e) => this.onPrint('excel')} style={{marginRight:8}}>Excel</button>
									<button type="button" className="btn btn-default" disabled={this.state.listado.length === 0} onClick={(e) => this.onPrint('pdf')}>PDF</button>
								</div>*/}
								<div className="col-xs-12 form-group" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="table-to-xls" 
											 ref={el => this.el = el}>
										</table>
									</div>
									
								</div>
								<div className='col-xs-12 form-group'>
									<Table responsive hover>
										<tbody>
											{this.state.totals !== '' &&
												<tr>
													<td colSpan={2}>
														Total
													</td>
													<td>{this.state.totals.donors}</td>
													<td>{this.state.totals.no_donors}</td>
													<td>{this.state.totals.total}</td>
												</tr>
											}					
										</tbody>
									</Table>
								</div>
								
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (DailyBiometrics);